module.exports = __webpack_public_path__ + "media/img/covers/team-cover-8ef39e2f7f1dd5e6f2eebf983187e02e.jpg";